import { LessonPlanSessionModel } from '../../object-actions/types/types';

/** Session-level: has this session been started? (LessonPlanSession.started_at) */
export function hasSessionStarted(session: LessonPlanSessionModel): boolean {
    return !!session.started_at;
}

/** Slide-level: do all slides in this session have started_at? (SessionSlide.started_at) */
export function areAllSlidesTrackedForSession(session: LessonPlanSessionModel): boolean {
    if (!session.slides || session.slides.length === 0) return false;
    for (let i = 0; i < session.slides.length; i++) {
        if (!session.slides[i]?.started_at) return false;
    }
    return true;
}

/** Index of the first session that does not have all slides tracked. Sessions are assumed backend-ordered. */
export function getFirstIncompleteSessionIndex(sessions: LessonPlanSessionModel[]): number {
    const i = sessions.findIndex((s) => !areAllSlidesTrackedForSession(s));
    return i === -1 ? 0 : i;
}

/** Index of the first slide without started_at. Slides are assumed backend-ordered. 0 if all started or no slides. */
export function getFirstUnstartedSlideIndex(session: LessonPlanSessionModel): number {
    const slides = (session.slides || []).filter((s) => s != null);
    const i = slides.findIndex((s) => !s?.started_at);
    return i === -1 ? 0 : i;
}
